module.exports = __webpack_public_path__ + "static/media/socialPiper-post-tabletPro-es.6f82e3cd.png";